import { render, staticRenderFns } from "./ReporteDetalle.vue?vue&type=template&id=93505310&"
import script from "./ReporteDetalle.vue?vue&type=script&lang=js&"
export * from "./ReporteDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports